import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { MyRequestedServices } from './my-requested-services.model';
import * as MyRequestedServicesActions from './my-requested-services.actions';

export const myRequestedServicesesFeatureKey = 'myRequestedServiceses';

export interface State extends EntityState<MyRequestedServices> {
  // additional entities state properties
}

export const adapter: EntityAdapter<MyRequestedServices> = createEntityAdapter<MyRequestedServices>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(MyRequestedServicesActions.addMyRequestedServices,
    (state, action) => adapter.addOne(action.myRequestedServices, state)
  ),
  on(MyRequestedServicesActions.upsertMyRequestedServices,
    (state, action) => adapter.upsertOne(action.myRequestedServices, state)
  ),
  on(MyRequestedServicesActions.addMyRequestedServicess,
    (state, action) => adapter.addMany(action.myRequestedServicess, state)
  ),
  on(MyRequestedServicesActions.upsertMyRequestedServicess,
    (state, action) => adapter.upsertMany(action.myRequestedServicess, state)
  ),
  on(MyRequestedServicesActions.updateMyRequestedServices,
    (state, action) => adapter.updateOne(action.myRequestedServices, state)
  ),
  on(MyRequestedServicesActions.updateMyRequestedServicess,
    (state, action) => adapter.updateMany(action.myRequestedServicess, state)
  ),
  on(MyRequestedServicesActions.deleteMyRequestedServices,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(MyRequestedServicesActions.deleteMyRequestedServicess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(MyRequestedServicesActions.loadMyRequestedServicess,
    (state, action) => adapter.setAll(action.myRequestedServicess, state)
  ),
  on(MyRequestedServicesActions.clearMyRequestedServicess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
